import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=4ceb0c9f&scoped=true&"
import script from "./logo.vue?vue&type=script&lang=ts&"
export * from "./logo.vue?vue&type=script&lang=ts&"
import style0 from "./logo.vue?vue&type=style&index=0&id=4ceb0c9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceb0c9f",
  null
  
)

export default component.exports